<template>
  <!-- 分配用户的对话框 -->
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/basic/plumberCompany/engineerCompany' }"
        >Basic data</el-breadcrumb-item>
      <el-breadcrumb-item>Parameter Setting</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack" content="Parameter Setting"></el-page-header>
    <el-divider></el-divider>
    <!-- 卡片视图区域 -->
    <el-card style="height: 800px">
           <div style="margin-bottom: 20px;">
            <el-button  
              v-if="isShowGroupBtn&&canSave"        
              icon="el-icon-circle-plus"
              size="small"
              @click="addGroup()"
            >Add Group</el-button>
          </div>
      <el-row>
        <el-col :span="3">
          <el-tree
            node-key="id"
            class="filter-tree"
            :data="treeData"
            :props="defaultProps"
            :default-expand-all="false"
            ref="tree"
            @node-click="handleNodeClick"
            :default-expanded-keys="expandKeys"
           :expand-on-click-node="false">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span>
                  <el-button
                    v-if="isShowGroupBtn&&canSave"
                    type="text"
                    size="mini"
                    @click="() => deleteGroup(node, data)">
                    Delete
                  </el-button>
                </span>
              </span>
          </el-tree>
        </el-col>

        <el-col :span="21">
          <el-card v-if="canSave&&currentParentId != null">
             <el-row>
               <el-col class="group_header">{{groupHeaderTitle}}</el-col>
             </el-row>
            <el-row>
              <el-form  :model="aggrement" ref="agreementForm" :rules="aggrementFormRules">
                <el-col :span="8">

                  <el-form-item
                    label="Group Name"
                    label-width="170px"
                    prop="groupName"
                  >

                  <el-input
                    @change="handleChange"
                    type="number"
                    v-model="aggrement.groupName"
                    style="width:80%"
                  >
                  </el-input>
                    kPa
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="Remark"
                    label-width="160px"
                    prop="Remark"
                  >
                    <el-input
                      placeholder=""
                      maxlength="30"
                      v-model="aggrement.remark"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="Test Type"
                    label-width="160px"
                    prop="testType"
                  >
                    <el-select
                      v-model="aggrement.testType"
                      placeholder=""
                    >
                      <el-option
                        v-for="item in selectTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item
                    label="Agreement"
                    label-width="160px"
                    prop="agreement"                
                  >
                    <el-input
                      type="textarea"
                      autosize
                      placeholder=""
                      v-model="aggrement.agreement"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
            <el-row type="flex" justify="end" v-if="isShowGroupBtn&&currentParentId <0&&canSave">
                <el-col :span="3"> 
                    <el-button
                      icon="el-icon-check"
                      size="small"
                      @click="saveAggrement()"
                    >Save Aggrement</el-button>
                  </el-col>
            </el-row>
            <el-row type="flex" justify="end">
              <el-col class="searchBtns" :span="6">
                <el-button-group>
                   <el-button
                     v-if="isShowGroupBtn&&currentParentId >0&&canSave"
                      icon="el-icon-check"
                      size="small"
                      @click="saveAggrement()"
                    >Save Aggrement</el-button>
                  <el-button
                    plain
                    size="small"
                    icon="el-icon-circle-plus"
                    v-if="isShowGroupBtn&&currentParentId >0&&canSave"
                    @click="showAddDialog"
                    >Add Round</el-button
                  >
                  <el-button
                    plain
                    size="small"
                    icon="el-icon-remove"
                    v-if="isShowGroupBtn&&currentParentId >0&&canSave"
                    @click="deletes"
                    >Delete Round</el-button
                  >
                </el-button-group>
              </el-col>
            </el-row>

            <!-- 列表区域 -->
            <el-table v-if="currentParentId != null"
              :data="dataList"
              border
              stripe
              @selection-change="handleSelectionChange"
              @sort-change="sortChange"
              align="center"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                label="Round"
                sortable="custom"
                prop="roundId"
                width="100px"
              ></el-table-column>
              <el-table-column
                label="Group pressure(kPa)"
                sortable="custom"
                prop="startPressure"
              ></el-table-column>
              <el-table-column
                label="Test duration(s)"
                sortable="custom"
                prop="testTime"
              ></el-table-column>
              <el-table-column
                label="prompt overpressure value(kPa)"
                sortable="custom"
                prop="overpressure"
              ></el-table-column>
              <el-table-column
                label="Exceed allowable starting pressure value(kPa)"
                sortable="custom"
                prop="cannotpressureNum"
              ></el-table-column>
              <el-table-column
                label="Whether as a criterion"
                sortable="custom"
                prop="decisionStandard"
              >
               <template slot-scope="scope">
                    <el-tag v-if="scope.row.decisionStandard==='Y'" type="success">Yes</el-tag>
                    <el-tag v-else-if="scope.row.decisionStandard==='N'" type="info">No</el-tag>
              </template>
              
              </el-table-column>
              <el-table-column
                label="Allowable pressure reduction range(kPa)"
                sortable="custom"
                prop="pressureDecRange"
              ></el-table-column>
              <el-table-column label="Operate" width="130px">
                <template slot-scope="scope">
                  <el-link v-if="isShowGroupBtn&&canSave"
                    icon="el-icon-edit-outline"
                    @click="showEditDialog(scope.row.id)"
                    >Edit</el-link
                  >
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页区域 -->
            <el-pagination v-if="currentParentId != null"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryInfoparams.current"
              :page-sizes="[10, 50, 100, 200]"
              :page-size="queryInfoparams.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </el-card>
        </el-col>
      </el-row>
    </el-card>

    <!-- 添加角色的对话框 -->
    <el-dialog
      :visible="addDialogVisible"
      width="60%"
      @close="closeDialog"
      slot="title"
    >
      <template slot="title">
        <div>
          <h3>{{dialogTitle}}</h3>
          <el-divider style="font-weight: bold"></el-divider>
        </div>
      </template>
      <!-- 内容主体区域 -->
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addFormRef"
        label-width="250px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="RoundId" prop="roundId" align="center">
              <el-input v-model="addForm.roundId" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Group pressure(kPa)" prop="startPressure">
              <el-input v-model="addForm.startPressure" type="number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Test duration(s)" prop="testTime">
              <el-input v-model="addForm.testTime" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="prompt overpressure value(kPa)"
              prop="overpressure"
            >
              <el-input v-model="addForm.overpressure" type="number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="Exceed allowable starting pressure value(kPa)"
              prop="cannotpressureNum"
            >
              <el-input v-model="addForm.cannotpressureNum" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Whether as a criterion"
              prop="decisionStandard"
            >
              <el-select
                v-model="addForm.decisionStandard"
                placeholder="please select"
              >
                <el-option label="Yes" value="Y"> </el-option>
                <el-option label="No" value="N"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="Allowable pressure reduction range(kPa)"
              prop="pressureDecRange"
            >
              <el-input v-model="addForm.pressureDecRange" type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Allow boost range(kPa)"
              prop="pressureRiseRange"
            >
              <el-input v-model="addForm.pressureRiseRange" type="number" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="saveRound">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      default: false,
    },
  },
  data() {
    var checkGroupName = (rule, value, cb) => {
      // 表单校验正则表达式
      const reg = /^[1-9][0-9]*([.][0-9]+)?$/
      if (reg.test(value)) {
        return cb()
      }
      cb(new Error('Group Name must be a number or decimal'))
    }
    return {
      num: 1,
      // 获取用户列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      // 控制添加 对话框的显示与隐藏
      addDialogVisible: false,
      //列表
      dataList: [],
      total: 0,
      //角色用户列表的checkbox值
      multipleSelection: [],
      //搜索列表的checkbox值
      multipleSelectionSearch: [],
      //搜索用户列表
      searchDataList: [],
      // 获取用户列表的参数对象
      searchQueryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      //组不能超过10个，否则不显示新增按钮
      isShowGroupBtn:true,

      //是否允许保存
      canSave:true,
      searchTotal: 0,
      treeName: this.$route.query.treeName + ' 树形列表',
      agentId: this.$route.query.agentId,
      companyId:this.$route.query.companyId,

      //当前点击的树节点ID，默认是-1第一层
      currentParentId: null,
      //搜索内容
      searchContent: null,

      filterText: '',
      //树列表 数据
      treeData: [],

      //展开的节点数组
      expandKeys: [-1],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      selectTypeOptions:[],
      //新增
      addForm: {
        status: 'Y',
      },
      // 添加表单的验证规则对象
      addFormRules: {
         roundId: [
          { required: true, message: 'Round can not be null', trigger: 'blur' },
        ],
        startPressure: [
          { required: true, message: 'Group pressure can not be null', trigger: 'blur' }
        ],
        testTime:[
          { required: true, message: 'Test duration can not be null', trigger: 'blur' }
        ],
        overpressure:[
          { required: true, message: 'overpressure value can not be null', trigger: 'blur' }
        ],
         cannotpressureNum:[
          { required: true, message: 'starting value can not be null', trigger: 'blur' }
        ],
         decisionStandard:[
          { required: true, message: 'please select', trigger: 'blur' }
        ],
         pressureDecRange:[
          { required: true, message: 'reduction range can not be null', trigger: 'blur' }
        ],
          pressureRiseRange:[
          { required: true, message: 'boost range can not be null', trigger: 'blur' }
        ]
      },
      aggrementFormRules:{
        groupName: [
          { required: true, message: 'please enter group name', trigger: 'blur' },
          { validator: checkGroupName },
        ],

        groupType: [
          { required: true, message: 'please choose the test type', trigger: 'blur' }
        ],
        agreement:[
          { required: true, message: 'please enter agreement content', trigger: 'blur' }
        ]
      },
      aggrement: {
        id: null,
        companyId: this.companyId,
        groupName: '',
        remark:'',
        testType: '',
        agreement: '',
      },

      dialogTitle:'',
      groupHeaderTitle:'',

      //判断是否第一次进去页面加载
      firstLoad:true,
    }
  },
  created() {
    this.getTreeData()
    this.getTestType()
    this.queryTestStandard()
    
    
    // this.getDataList()
  },
  methods: {

    handleChange(value){
      console.log(value);
    },
    //导出excel
    exportExcel() {
      console.log('-----------')
      var params = { treeId: this.treeId }

      let res = this.$export(
        'tree/item/exportExcel',
        JSON.stringify(params),
        'tree'
      )
    },
    addGroup() {
        // let count= this.treeData.length+1;
        // const newChild = {id:-count,label: 'Group'+count};
        // this.isShowGroupBtn = true;
        // if(count>=10){
        //   this.isShowGroupBtn = false;
        // }else{
        //     this.isShowGroupBtn = true;
        // }
        // this.treeData.push(newChild);
      let count = this.treeData.length + 1
      const newChild = { id: -count, label: 'Group' + count }
      this.currentParentId = -count
      console.log('currentParentId==', this.currentParentId)
      this.treeData.push(newChild)
      if (count >= 10) {
        this.isShowGroupBtn = false
      } else {
        this.isShowGroupBtn = true
      }
      //切换表单
      this.handleNodeClick(newChild)
    },


    queryTestStandard(){
       this.$post('/engineerCompany/queryTestStandard',{companyId:this.companyId}).then(({data:res})=>{
              console.log(res.data);
              this.canSave=res.data;
       })
    },

    //监听字段排序
    sortChange(r) {
      //设置排序字段名
      this.queryInfoparams.sortField = r.prop
      //设置排序字段名
      this.queryInfoparams.sortOrder = r.order

      this.getDataList()
    },
    getEntity(aggrementId){
      this.$get(`/companyAgreement/queryAgreementById/${aggrementId}`).then(
          ({ data: res }) => {
            if (res.ok) {

              // console.log(res);
              this.aggrement = res.data
            }
          }
        )
    },

    queryTestStandard(){
       this.$post('/engineerCompany/queryTestStandard',{companyId:this.companyId}).then(({data:res})=>{
              console.log(res.data);
              this.isShowGroupBtn=res.data;
       })
    },
    // 获取 查询用户数据列表
    getDataList() {
      // 分页查询用户
      this.queryInfoparams.params.companyId = this.companyId
      this.queryInfoparams.params.groupId = this.currentParentId
      this.$post(
        '/compangDeviceOption/queryDeviceOptionByGroup',
        this.queryInfoparams
      ).then(({ data: res }) => {
        this.dataList = res.records
        this.total = res.total
      })
    },
    getTreeData() {
      this.$get(`companyAgreement/getGroupTree/${this.companyId}`).then(
        ({ data: res }) => {
          console.log(res)
          this.treeData = res.data
          if(this.firstLoad){
            if(this.treeData.length>0){
              this.handleNodeClick(this.treeData[0])
            }
            this.firstLoad=false
          }
        }
      )
    },
      // 获取 testType可选择的项
    getTestType() {

      this.$get(`dict/getByTypeCode/TEST_TYPE/Y`).then(({ data: res }) => {
        for (let i in res.data) {
          res.data[i].label = res.data[i].item_name
          res.data[i].value = res.data[i].item_code
        }
        this.selectTypeOptions = res.data
      })

    },
    handleNodeClick(data) {

         console.log(data.id)
      this.groupHeaderTitle = data.label
      if (data.id == undefined || data.id == null || data.id < 0) {
        this.currentParentId = data.id
        this.aggrement = {}
        this.dataList = []
        this.total = 0
      } else {
        this.currentParentId = data.id
        this.getEntity(this.currentParentId)
        this.getDataList()
      }    
     
    },
    showAddDialog() {
      this.addDialogVisible = true
      this.dialogTitle='Add Round'
    },
    showEditDialog(id) {
    
      this.addDialogVisible = true
       this.dialogTitle='Edit Round'
      this.$get(`compangDeviceOption/queryById/${id}`).then(({ data: res }) => {
        console.log(res)
        this.addForm = res
      })
    },
    closeDialog() {
      this.addForm = { }
      this.addDialogVisible = false
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },
    // 监听对话框的关闭事件
    goBack() {
      this.$router.back()
    },
    // 点击按钮 新增保存协议
   async saveAggrement() {
      console.log("baocun" , this.aggrement)
      this.$refs.agreementForm.validate(async (valid) => {
          this.aggrement.companyId = this.companyId
        //父级ID
        if (!valid) return
        this.$post('companyAgreement/save', this.aggrement).then(({ data: res }) => {
          debugger
          if (res.ok) {
            debugger
            // 刷新列表数据
               // 刷新列表数据
              this.getDataList()
              this.getTreeData()
              this.currentParentId = res.data.id
              var node = {
                id: this.currentParentId,
                label: this.groupHeaderTitle,
              }
              this.handleNodeClick(node)
              return this.$message.success(res.msg)
              loading.close()
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },

    //保存
   async saveRound(){
        this.$refs.addFormRef.validate(async (valid) => {
          this.addForm.companyId = this.companyId
          this.addForm.groupId = this.currentParentId
           this.addForm.testType = this.aggrement.testType
        //父级ID
        if (!valid) return

        this.$post('compangDeviceOption/save', this.addForm).then(({ data: res }) => {
          if (res.ok) {
            // 刷新列表数据
            this.getDataList()
            this.closeDialog()
            return this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },

    //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
    },

    //监控搜索页面 checkbox的选择,为entity的所有值
    handleSelectionChangeSearch(val) {
      this.multipleSelectionSearch = val
      console.log(this.multipleSelectionSearch)
    },
    // 删除组
    async deleteGroup(node, data) {

      const groupId = data.id

      if(groupId <0){
          this.getTreeData()
        return;
      }

      // 弹框询问用户是否删除
      const confirmResult = await this.$confirm(
        'it is will delete group,dou you continute?',
        'delete group',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      ).catch((err) => err)
      // 如果用户确认删除 则 返回值为字符串 confirm
      // 如果用户取消删除 则 返回值为字符串 cancel

      this.$delete(`companyAgreement/deleteGroup/${groupId}`).then(
        ({ data: res }) => {
          if (!res.ok) {
            return this.$message.error(res.msg)
          }
          this.$message.success(res.msg)

          this.getTreeData()
        }
      )
    },
    // 批量删除轮数
    async deletes() {
      if (
        this.multipleSelection == null ||
        this.multipleSelection.length <= 0
      ) {
        return this.$message.error('please select one record !')
      }

      var ids = []
      this.multipleSelection.forEach((row) => {
        ids.push(row.id)
      })

      console.log(ids)

      // 弹框询问用户是否删除
      const confirmResult = await this.$confirm(
        'it is will delete,dou you continute?',
        'delete round',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      ).catch((err) => err)
      // 如果用户确认删除 则 返回值为字符串 confirm
      // 如果用户取消删除 则 返回值为字符串 cancel

      this.$delete(`compangDeviceOption/delete`, { idList: ids }).then(
        ({ data: res }) => {
          if (!res.ok) {
            return this.$message.error(res.msg)
          }
          this.$message.success(res.msg)

          this.getDataList()
        }
      )
    },
  },
}
</script>

<style lang="less" scoped>
.rightContent {
  display: flex;
  .el-input {
    margin-right: 10px;
  }
}
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}

 .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .group_header {
    font-weight:bold ;
    margin-bottom: 20px;
  }
</style>